{
  "actions": {
    "approve": "Approve",
    "reject": "Reject",
    "return": "Return",
    "cancel": "Cancel",
    "delegate": "Delegate",
    "escalate": "Escalate",
    "cancelRequest": "Cancel request",
    "resubmit": "Resubmit for approval",
    "editResubmit": "Edit & resubmit",
    "reviewResubmit": "Review & resubmit",
    "viewInInbox": "View in inbox"
  },
  "form": {
    "commentsPlaceholder": "Comments (optional)",
    "delegateRequired": "Select an employee to delegate to"
  },
  "status": {
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected",
    "returned": "Returned",
    "cancelled": "Cancelled",
    "completed": "Completed",
    "draft": "Draft",
    "submitted": "Submitted",
    "escalated": "Escalated",
    "done": "Done"
  },
  "entity": {
    "leave": "Leave",
    "attendance": "Attendance",
    "expense": "Expense claim",
    "overtime": "Overtime",
    "payroll": "Payroll run"
  },
  "inbox": {
    "title": "Approval inbox",
    "type": "Type",
    "employee": "Employee",
    "step": "Step",
    "status": "Status",
    "submitted": "Submitted",
    "sla": "SLA",
    "actions": "Actions",
    "onlyMine": "Assigned to me",
    "submittedByMe": "Submitted by me",
    "delegatedToMe": "Delegated to me",
    "allStatuses": "All",
    "timeline": "Approval timeline",
    "noItems": "No approval items match your filters",
    "actionDone": "Request {{status}}",
    "resubmitted": "Resubmitted · {{status}}",
    "failedLoad": "Failed to load approvals",
    "actionFailed": "Approval action failed",
    "delegations": "Delegations",
    "builder": "Workflow builder"
  },
  "toast": {
    "workflowUpdated": "Workflow updated",
    "workflowCreated": "Workflow created",
    "workflowActivated": "Workflow activated",
    "workflowDeactivated": "Workflow deactivated",
    "workflowCloned": "Workflow cloned",
    "delegationCreated": "Delegation created",
    "delegationDeactivated": "Delegation deactivated",
    "resubmittedForApproval": "Resubmitted for approval",
    "attendanceUpdatedResubmitWhenReady": "Attendance updated — resubmit when ready",
    "leaveUpdatedResubmitWhenReady": "Leave updated — resubmit when ready",
    "requestStatus": "Request {{status}}"
  },
  "errors": {
    "aWorkflowMustHaveAtLeastOneApproval": "A workflow must have at least one approval step",
    "codeAndNameAreRequired": "Code and name are required",
    "addAtLeastOneApprovalStep": "Add at least one approval step",
    "selectAnOrgRoleForEachStepThat": "Select an org role for each step that uses Specific org role",
    "enterAUserIdForEachStepThat": "Enter a user ID for each step that uses Specific user",
    "selectARoleForSlaReassignment": "Select a role for SLA reassignment",
    "selectAnEmployeeWithALoginAccountFor": "Select an employee with a login account for SLA reassignment",
    "failedToLoadWorkflows": "Failed to load workflows",
    "failedToSaveWorkflow": "Failed to save workflow",
    "activateFailed": "Activate failed",
    "deactivateFailed": "Deactivate failed",
    "cloneFailed": "Clone failed",
    "delegateEmployeeAndEndDateAreRequired": "Delegate employee and end date are required",
    "failedToCreateDelegation": "Failed to create delegation",
    "failedToDeactivateDelegation": "Failed to deactivate delegation",
    "failedToLoadApprovalMatrix": "Failed to load approval matrix",
    "approvalActionFailed": "Approval action failed",
    "checkInTimeIsRequired": "Check-in time is required",
    "checkOutMustBeAfterCheckIn": "Check-out must be after check-in",
    "failedToUpdateAttendance": "Failed to update attendance",
    "leaveTypeAndAtLeastOneDayAre": "Leave type and at least one day are required",
    "leaveReasonIsRequired": "Leave reason is required",
    "failedToUpdateLeave": "Failed to update leave",
    "selectedEmployeeNoUserAccount": "Selected employee has no user account linked",
    "cannotDelegateToYourself": "Cannot delegate to yourself",
    "failedToLoadEmployees": "Failed to load employees"
  },
  "pages": {
    "approvalWorkflows": "Approval Workflows",
    "approvalDelegations": "Approval delegations",
    "approvalMatrix": "Approval Matrix",
    "myApprovals": "My Approvals",
    "pendingApprovals": "Pending approvals"
  },
  "matrix": {
    "description": "Who approves what in {{module}} — action, conditions, approvers, SLA, and escalation",
    "openBuilder": "Open Builder",
    "empty": "No approval workflows configured. Create workflows in the Approval Builder."
  },
  "delegations": {
    "description": "Temporary approval delegation for {{module}}",
    "myWork": "My Work",
    "approvals": "Approvals",
    "delegations": "Delegations",
    "delegator": "Delegator",
    "delegate": "Delegate",
    "module": "Module",
    "from": "From",
    "to": "To",
    "deactivate": "Deactivate",
    "createDelegation": "Create delegation",
    "empty": "No delegations configured"
  },
  "builder": {
    "description": "Design {{module}} approval chains without code — sequential, parallel, or hybrid",
    "editWorkflow": "Edit workflow",
    "createWorkflow": "Create workflow",
    "updateWorkflow": "Update workflow",
    "workflowsTitle": "{{module}} workflows",
    "empty": "No workflows yet — create your first approval chain",
    "stepDefaultName": "Step {{order}}",
    "stepLabel": "Step {{order}}",
    "stepNameLabel": "Step {{order}} name",
    "conditionTitle": "Condition (optional)",
    "stepsTitle": "Approval steps",
    "stepsHelp": "Define who approves each step. Use reporting manager for org hierarchy, or choose a specific org role from Organization → Roles.",
    "addStep": "Add step",
    "remove": "Remove",
    "approvers": "Approvers",
    "addApprover": "Add approver",
    "approverN": "Approver {{n}}",
    "clone": "Clone",
    "archived": "Archived",
    "assigneeNotConfigured": "Not configured",
    "assigneeSelectRole": "Select an org role below",
    "assigneeRoleCode": "Role: {{code}}",
    "assigneeUserId": "User ID {{id}}",
    "assigneeEnterUserId": "Enter the approver user ID"
  },
  "approvalTypes": {
    "SEQUENTIAL": "Sequential",
    "PARALLEL": "Parallel",
    "HYBRID": "Hybrid"
  },
  "policies": {
    "missing": {
      "AUTO_APPROVE": "Auto approve when approver missing",
      "BLOCK_SUBMISSION": "Block submission (configuration error)",
      "ESCALATE": "Escalate to next level / SLA rule"
    },
    "sla": {
      "AUTO_APPROVE": "Auto-approve (direct approval)",
      "REASSIGN": "Reassign to another approver",
      "NOTIFY": "Extend SLA (reminder)"
    }
  },
  "conditions": {
    "equals": "Equals",
    "inList": "In list"
  },
  "escalateTo": {
    "orgRole": "Org role",
    "specificEmployee": "Specific employee"
  },
  "table": {
    "action": "Action",
    "name": "Name",
    "type": "Type",
    "status": "Status",
    "workflow": "Workflow",
    "conditions": "Conditions",
    "approvers": "Approvers",
    "sla": "SLA",
    "escalation": "Escalation",
    "active": "Active",
    "inactive": "Inactive"
  },
  "timeline": {
    "empty": "No actions recorded yet.",
    "delegatedTo": "Delegated to",
    "by": "By",
    "unknownUser": "Unknown user",
    "userRef": "User #{{id}}",
    "actions": {
      "SUBMIT": "Request submitted",
      "APPROVE": "Approved",
      "AUTO_APPROVE": "Auto-approved",
      "REJECT": "Rejected",
      "RETURN": "Returned for correction",
      "REQUEST_CHANGES": "Changes requested",
      "DELEGATE": "Delegated",
      "ESCALATE": "Escalated",
      "SLA_AUTO_APPROVE": "Auto-approved (SLA expired)",
      "SLA_ESCALATE": "Reassigned (SLA expired)",
      "SLA_NOTIFY": "SLA reminder",
      "CANCEL": "Cancelled",
      "RESUBMIT": "Resubmitted",
      "COMMENT": "Comment added",
      "SYSTEM_NOTE": "System note"
    }
  },
  "returned": {
    "title": "Returned for changes",
    "defaultComment": "The approver asked you to revise this request before resubmitting.",
    "editRequest": "Edit request",
    "essLeavePrefix": "Or open",
    "essLeaveLink": "self-service leave",
    "essLeaveSuffix": "to edit from your portal.",
    "resubmitHint": "Save edits first, then resubmit to restart approval."
  },
  "guide": {
    "title": "Approver types guide",
    "subtitle": "Who gets the request, why, and a real-world example for each type.",
    "hide": "Hide guide",
    "show": "View guide",
    "example": "Example:",
    "resolvesTo": "This step resolves to:",
    "flowHint": "Each request shows who must approve it next under Pending with — resolved from reporting lines, roles, or named users on the workflow step."
  },
  "inboxExt": {
    "description": "Approval inbox for {{module}} — only requests for you and your reporting team",
    "view": "View",
    "refresh": "Refresh",
    "pendingWith": "Pending with",
    "overdue": "Overdue",
    "stepN": "Step {{n}}",
    "emptyView": "No approval requests in this view",
    "myQueueOnly": "My queue only",
    "allRequests": "All requests",
    "slaDeadline": "SLA deadline",
    "currentStep": "Current step",
    "details": "Details",
    "overdueSuffix": "(overdue)",
    "kpiPendingForMe": "Pending for me",
    "kpiDelegatedToMe": "Delegated to me",
    "kpiSubmittedByMe": "Submitted by me",
    "kpiReturnedToMe": "Returned to me",
    "kpiApprovedByMe": "Approved by me",
    "kpiRejectedByMe": "Rejected by me",
    "kpiMyActions": "My actions"
  },
  "labels": {
    "code": "Code",
    "name": "Name",
    "action": "Action",
    "approvalType": "Approval type",
    "slaHours": "SLA (hours)",
    "afterSlaExpires": "After SLA expires",
    "escalateTo": "Escalate to",
    "escalationRole": "Escalation role",
    "escalationEmployee": "Escalation employee",
    "missingApproverPolicy": "Missing approver policy",
    "stepGroupSameGroupParallel": "Step group (same group = parallel)",
    "approverType": "Approver type",
    "orgRole": "Org role",
    "approverUserId": "Approver user ID",
    "selectRole": "Select role",
    "selectEmployee": "Select employee",
    "reason": "Reason",
    "effectiveUntil": "Effective until",
    "selectDelegate": "Select delegate",
    "checkIn": "Check in",
    "checkOut": "Check out",
    "timeline": "Timeline"
  }
}
